import Link from "next/link";

import { Icon } from "@/components/elements/Icon";
import { LINKS } from "@/constants/links";

import footer from "../footer.module.css";

const Socials = [
  {
    href: LINKS.INSTAGRAM,
    icon: "instagram",
    label: "Instagram",
  },
  {
    href: LINKS.FACEBOOK,
    icon: "facebook",
    label: "Facebook",
  },
  {
    href: LINKS.LINKEDIN,
    icon: "linkedin",
    label: "Linkedin",
  },
];

const LinkItem = ({ href, icon, label }) => (
  <li>
    <Link href={href} target="_blank" rel="noopener noreferrer">
      <Icon type={icon} label={label} />
    </Link>
  </li>
);

export const SocialLinks = () => (
  <ul className={footer.socials}>
    {Socials.map((link) => (
      <LinkItem key={link.href} {...link} />
    ))}
  </ul>
);
